import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconCalendarSolid = function IconCalendarSolid(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-calendar-solid"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "M22 8v1H2V8a3 3 0 0 1 3-3h1V4a1 1 0 0 1 2 0v1h8V4a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3M2 11h20v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm14 2.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-5 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-5-3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
  }, pathRest)));
};
IconCalendarSolid.displayName = 'InlineIcon(IconCalendarSolid)';
IconCalendarSolid.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconCalendarSolid };
